import {Checkbox, Typography,} from "@material-ui/core";
import React from "react";
import './FeeSelector.scss';

export type FeeOptionKey = "APPRAISAL" | "CREDIT_REPORT";

const FEE_OPTIONS: { key: FeeOptionKey; label: string; description: string; icon: string }[] = [
    {
        key: "APPRAISAL",
        label: "Appraisal Fee",
        description: "Professional property valuation",
        icon: "🏠"
    },
    {
        key: "CREDIT_REPORT",
        label: "Credit Report Fee",
        description: "Credit history verification",
        icon: "📊"
    },
];

interface FeeSelectorProps {
    selectedFees: FeeOptionKey[];
    toggleFee: (key: FeeOptionKey) => void;
    appraisalFeeEnabled: boolean;
    creditReportFeeEnabled: boolean;
    loanData?: {
        appraisalFee: string;
        creditReportFee: string;
    };
}

export function FeeSelector({
                                selectedFees,
                                toggleFee,
                                appraisalFeeEnabled,
                                creditReportFeeEnabled,
                                loanData,
                            }: FeeSelectorProps) {

    const getFeeAmount = (key: FeeOptionKey) => {
        if (!loanData) return '';
        return key === 'APPRAISAL' ? loanData.appraisalFee : loanData.creditReportFee;
    };

    const calculateTotal = () => {
        if (!loanData) return 0;
        let total = 0;
        if (selectedFees.includes('APPRAISAL')) {
            total += parseFloat(loanData.appraisalFee.replace(/[$,]/g, ''));
        }
        if (selectedFees.includes('CREDIT_REPORT')) {
            total += parseFloat(loanData.creditReportFee.replace(/[$,]/g, ''));
        }
        return total.toFixed(2);
    };

    return (
        <div className="fee-selector">
            <div className="fee-selector-header">
                <Typography variant="subtitle1">
                    Select fees to include
                </Typography>
            </div>

            <div className="fee-options-container">
                {FEE_OPTIONS.map((opt) => {
                    const isAppraisal = opt.key === "APPRAISAL";
                    const isCreditReport = opt.key === "CREDIT_REPORT";
                    const disabled = (isAppraisal && !appraisalFeeEnabled) || (isCreditReport && !creditReportFeeEnabled);
                    const isSelected = selectedFees.includes(opt.key);
                    const feeAmount = getFeeAmount(opt.key);

                    return (
                        <div
                            key={opt.key}
                            className={`fee-option-item ${isSelected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
                            onClick={() => {
                                if (!disabled) toggleFee(opt.key);
                            }}
                        >
                            <div className="fee-option-content">
                                <div className="fee-icon">
                                    {opt.icon}
                                </div>

                                <div className="fee-text">
                                    <div className="fee-label">
                                        {opt.label}
                                    </div>
                                    <div className="fee-description">
                                        {opt.description}
                                    </div>
                                </div>

                                <div className="fee-amount">
                                    {feeAmount}
                                </div>

                                <Checkbox
                                    checked={isSelected}
                                    disabled={disabled}
                                    color="primary"
                                    style={{ marginLeft: 8 }}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>

            {selectedFees.length > 0 && (
                <div className="fee-total">
                    <div className="total-label">
                        Total Selected Fees:
                    </div>
                    <div className="total-amount">
                        ${calculateTotal()}
                    </div>
                </div>
            )}
        </div>
    );
}
